import { render } from "./FormBuilder.vue?vue&type=template&id=2a229d6a"
import script from "./FormBuilder.vue?vue&type=script&lang=js"
export * from "./FormBuilder.vue?vue&type=script&lang=js"

import _style_0 from "./FormBuilder.vue?vue&type=style&index=0&id=2a229d6a&inline&lang=scss"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__